import api from './api'

export const deployment = {
  deploymentList: (params) => {
    return api.post(`/CloudParkAPI/card/DeploymentQuery`, params)
  },
  saveDeploymentPlate: (params) => {
    return api.post(`/CloudParkAPI/card/SaveDeploymentPlate`, params)
  },
  deleteDeploymentPlate: (params) => {
    return api.post(`/CloudParkAPI/card/deleteDeploymentPlate`, params)
  },
  synDeploymentPlateById: (params) => {
    return api.post(`/CloudParkAPI/card/SynDeploymentPlateById`, params)
  },
  getParkReserveList: (params) => {
    return api.post(`/CloudParkAPI/card/GetParkReserveList`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/deploymentCar.js